<template>
	<div>
		<div class="answer-block">
			<h1 role="alert" aria-live="assertive" tabindex="0" class="ada-focus">I'd like to cancel this book</h1>

			<div v-if="!loading && !is_ia_item">
				<p v-if="show_return_page_link">This order could not be canceled because it has already shipped.
					After receiving the order you can <a class="help-link" href="/returns">return it</a><span v-if="ol_type === 'ebook'"> (<a class="help-link" href="/returns#ebook_refund_policy">please check ebook returns policy</a>)</span>.</p>

				<div class="h-email-form" v-if="show_return_page_link || show_email">
					<email-form
						caption="This item couldn’t be auto canceled. Email us:"
						:subject="
							show_return_page_link
							? 'I want to cancel this item but it already shipped'
							: 'My item couldn`t be auto canceled'
						"
						:body="
							show_return_page_link
							? 'Hello, I recently tried to cancel this item but your system would not allow me because it says that item has already shipped.'
							: 'I would like to cancel this item, but it couldn’t be auto canceled, can you please get it canceled for me?'
						"
						action="/service/customer_help/rest/index.php/customer_help/send_product_cancel_cs_request"
						on-success-url="/help?#/submitted"
						edit-body
						:payload="{ order_line_id }"
						destination-key="cs"
					></email-form>
				</div>


				<v-btn color="#7DADED" large round dark class="mb-3" @click="cancelNow" v-if="!show_email && !show_return_page_link">Cancel Now!</v-btn>
				<v-btn color="#7DADED" large round dark class="mb-3" to="/no_problem">Nevermind, I decided to keep it</v-btn>
			</div>

			<p v-if="!loading && is_ia_item">
				This item is an {{ inclusive_access_name }} item, and cannot be canceled. If you drop the course within the add drop period, you will be refunded for it as part of your tuition refund.
			</p>

		</div>

		<base-nav-links></base-nav-links>
	</div>
</template>

<script>
	import 'babel-polyfill';
	import Axios from 'axios';
	import BaseNavLinks from './../../../components/BaseNavLinks';
	import EmailForm from './../../../components/EmailForm';

	export default {
		name: "ConfirmCancel",

		components: {
			BaseNavLinks,
			EmailForm,
		},

		data() {
			return {
				show_email: false,
				show_return_page_link: false,
				order_line_id: null,
				is_ia_item: false,
				ol_type: 'new',
				loading: false
			};
		},

		mounted() {
			const self = this;
			self.loading = true;

			self.order_line_id = parseInt(self.$route.params.id);

			Axios.get('/service/customer_help/rest/index.php/customer_help/check_if_ia_item/' + parseInt(self.$route.params.id))
				.then(function (response) {
					if (response.status === 200 && response.data) {
						if (
							!_.isUndefined(response['data']['data']['is_inclusive_access_item'])
							&& response['data']['data']['is_inclusive_access_item'] == true
						) {
							self.is_ia_item = true;
						}
					}
				})
				.finally(function () {
					self.loading = false;
				});
		},

		computed: {
			inclusive_access_name() {
				return this.$globs.institute_info.inclusive_access_name;
			},
		},

		methods: {
			cancelNow() {
				const self = this;
				self.loading = true;

				Axios.get('/service/customer_help/rest/index.php/customer_help/cancel_order_line/' + parseInt(self.$route.params.id))
					.then(function (response) {
						if (response.status === 200 && response.data) {
							let d = response['data']['data'];
							self.ol_type = d['order_line_type'];
							if (!d['can_cancel'] || !d['cancel_result']) {
								if (d['has_tracking_number']) {
									self.show_return_page_link = true;
								} else {
									self.order_id = d['order_id'];
									self.isbn = d['isbn'];
									self.show_email = true;
									self.order_line_id = parseInt(self.$route.params.id);
								}
							} else {
								self.$router.push('/canceled_successfully');
								return;
							}
						}
					})
					.finally(function () {
						self.loading = false;
					});

			}
		},
	}
</script>

<style scoped lang="less">
	.h-email-form {
		margin-top: 20px;
	}
</style>